module.exports = __webpack_public_path__ + "img/icon-building-green.7a2460bf.svg";